"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _FormHint = _interopRequireDefault(require("../../structure/FormHint"));
var _Label = _interopRequireDefault(require("../../structure/Label"));
var _FormRow = _interopRequireDefault(require("../../structure/FormRow"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function RadioGroupComponent(props) {
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    _onChange = props.onChange,
    rowClass = props.rowClass,
    errors = props.errors,
    disabled = props.disabled,
    readOnly = props.readOnly,
    warning = props.warning,
    info = props.info,
    choices = props.choices,
    currentChoice = props.currentChoice,
    _props$wrapperClass = props.wrapperClass,
    wrapperClass = _props$wrapperClass === void 0 ? '' : _props$wrapperClass,
    _props$labelClass = props.labelClass,
    labelClass = _props$labelClass === void 0 ? 'form-label form-label--radio' : _props$labelClass,
    _props$inputClass = props.inputClass,
    inputClass = _props$inputClass === void 0 ? 'form-element form-element--radio' : _props$inputClass,
    _props$errorClass = props.errorClass,
    errorClass = _props$errorClass === void 0 ? 'form-element--has-error' : _props$errorClass;
  var hasErrors = !!errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : '';
  var wrapperClassName = hasErrors ? "".concat(wrapperClass, " ").concat(errorClass) : wrapperClass;
  return /*#__PURE__*/React.createElement(_FormRow.default, {
    className: rowClass,
    hasErrors: hasErrors
  }, Object.keys(choices !== null && choices !== void 0 ? choices : {}).map(function (key, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: wrapperClassName
    }, /*#__PURE__*/React.createElement("input", {
      ref: inputRef,
      type: "radio",
      name: name,
      id: "".concat(id, "-").concat(index),
      className: inputClass,
      checked: key === currentChoice,
      value: key,
      onChange: function onChange(event) {
        return _onChange === null || _onChange === void 0 ? void 0 : _onChange(event.target.value);
      },
      disabled: disabled,
      readOnly: readOnly
    }), /*#__PURE__*/React.createElement(_Label.default, {
      id: "".concat(id, "-").concat(index),
      className: labelClass
    }, choices === null || choices === void 0 ? void 0 : choices[key]));
  }), /*#__PURE__*/React.createElement(_FormHint.default, {
    error: errorMessage,
    warning: warning,
    info: info
  }));
}
function RadioGroup(props, ref) {
  return /*#__PURE__*/React.createElement(_reactHookForm.Controller, _extends({}, props, {
    render: function render(_ref) {
      var _ref$field = _ref.field,
        onChange = _ref$field.onChange,
        onBlur = _ref$field.onBlur,
        value = _ref$field.value;
      return /*#__PURE__*/React.createElement(RadioGroupComponent, _extends({
        inputRef: ref !== null && ref !== void 0 ? ref : null
      }, props, {
        onChange: onChange,
        onBlur: onBlur,
        currentChoice: String(value !== null && value !== void 0 ? value : '')
      }));
    }
  }));
}
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(RadioGroup);